"use client";

function MaskingImage() {
  return (
    <div className="basis-0 grow min-h-px min-w-px overflow-clip relative shrink-0 w-[555px]">
      <div className="absolute bg-center bg-cover bg-no-repeat h-[293px] left-[109px] top-[79px] w-[341px]" style={{ backgroundImage: `url('/images/d4190f0c1713491edc166c7aff72123745cb7e8d.png')` }} />
      <div className="absolute left-[25px] size-[530px] top-[185px]">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 530 530">
          <circle cx="265" cy="265" fill="url(#paint0_linear_1_4827)" id="Ellipse 601" opacity="0.4" r="265" />
          <defs>
            <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_1_4827" x1="265" x2="265" y1="0" y2="302">
              <stop stopColor="#E4E5E9" />
              <stop offset="0.9" stopColor="#444444" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="absolute bg-[rgba(255,255,255,0.3)] h-4 left-[453px] rounded-[40px] top-[75px] w-11" />
      <div className="absolute bg-[rgba(255,255,255,0.6)] h-4 left-0 rounded-[40px] top-[178px] w-11" />
      <div className="absolute bg-[rgba(255,255,255,0.6)] h-8 left-[19px] rounded-[40px] top-[138px] w-[88px]" />
    </div>
  );
}

function ImageArea() {
  return (
    <div className="[grid-area:1_/_2] relative shrink-0">
      <div className="flex flex-col justify-end overflow-clip relative size-full">
        <div className="box-border content-stretch flex flex-col items-start justify-end pl-[110px] pr-0 py-0 relative size-full">
          <MaskingImage />
        </div>
      </div>
    </div>
  );
}

function SignupButton() {
  return (
    <button className="bg-[#ffffff] box-border content-stretch flex gap-2.5 h-14 items-center justify-center px-8 py-4 relative rounded-[8px] shrink-0 hover:bg-gray-100 transition-colors cursor-pointer" type="button" aria-label="회원가입 하러 가기">
      <div className="font-['Pretendard:SemiBold',_sans-serif] leading-[0] not-italic relative shrink-0 text-[#010103] text-[20px] text-nowrap tracking-[-0.4px]">
        <p className="leading-[normal] whitespace-pre">회원가입 하러 가기</p>
      </div>
    </button>
  );
}

function SignupBannerText() {
  return (
    <div className="content-stretch flex flex-col gap-8 items-start justify-start relative shrink-0">
      <div className="font-['Pretendard:SemiBold',_sans-serif] leading-[0] not-italic relative shrink-0 text-[#ffffff] text-[32px] text-nowrap whitespace-pre">
        <p className="leading-[1.5] mb-0 text-[32px]">하루를 바꾸는 작은 변화, 매일의 흐름을 더 깊이 있게.</p>
        <p className="leading-[1.5]"><span className="text-[#94b2ff]">DW.Insights</span>와 함께 하세요.</p>
      </div>
      <SignupButton />
    </div>
  );
}

function TextArea() {
  return (
    <div className="[grid-area:1_/_1] relative shrink-0">
      <div className="flex flex-col items-end justify-center overflow-clip relative size-full">
        <div className="box-border content-stretch flex flex-col items-end justify-center p-[10px] relative size-full">
          <SignupBannerText />
        </div>
      </div>
    </div>
  );
}

function TwoColumnContainer() {
  return (
    <div className="grid grid-cols-[repeat(2,_minmax(0px,_1fr))] grid-rows-[repeat(1,_minmax(0px,_1fr))] h-[460px] max-w-[1920px] mx-auto overflow-clip relative w-full">
      <ImageArea />
      <TextArea />
    </div>
  );
}

export function SignupBannerSection() {
  return (
    <div className="hidden bg-[#444444] relative w-full">
      <TwoColumnContainer />
    </div>
  );
}

